import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
// import 'bootstrap/dist/css/bootstrap.min.css';

const faqs = [
  {
    question: "What is the process of booking appointments?",
    answer: "Our International Patient Coordinator will liaise between you and the hospital. He / She will arrange your appointments as well as coordinate for various services like the outpatient clinic, laboratory, and pathology, medical imaging, and in-patient surgical procedures, etc."
  },
  {
    question: "What are the facilities for international patients?",
    answer: `Airport pickup and drop-off services are available for admitted patients\nVISA / FRRO assistance\nLanguage interpreters\nForeign exchange conversion assistance and guidance are available within the hospital\nIn-room colour television & cable connection\nComplimentary Wi-Fi\nComplimentary stay in your room for one attendant\nOn-demand special arrangements can be made to fulfil specific religious or dietary needs\nRegular updates for your referring doctors & family`
  },
  {
    question: "How to get a medical opinion, so accordingly I can plan my visit?",
    answer: "You can share your medical history, current clinical reports, scans, and previous treatment details with us via email or WhatsApp at +91 85489 79899. Our team of expert doctors will review your case and provide a personalised cost estimate and treatment plan before your arrival."
  },
  {
    question: "What are the modes of payment acceptable at Columbiaa Hospital?",
    answer: "At the time of admission, payment can be made through cash/credit cards. Authorised Foreign currency exchange counter is available in-house. The payments can also be transferred directly to the Hospital’s account through wire transfer before the arrival or through traveller’s cheque. On discharge, any excess amount will be refunded to you and any shortfall will have to be paid in cash. Official receipts will be provided at every stage."
  },
  {
    question: "Do you provide accommodation & meal to the patient's attendant?",
    answer: "Yes, the attendant can stay with the patient in the room (except ICU stay). We also provide complimentary meals to the attendant ( Chargable )."
  },
  {
    question: "Do you help with booking the accommodation?",
    answer: "We have a tie-up with hotels / guest houses / service apartments in the vicinity of the hospital for our international patients. We share the list of the same in advance with our patients. They can do the booking directly or let us know to do the same on their behalf."
  },
  {
    question: "Do you assist with airport transfers to international patients?",
    answer: "Yes, We provide complimentary airport pick-up and drop-off services for all international inpatients We organise the pickup on receiving the patient's travel details."
  },
  {
    question: "Do you provide medical visa support?",
    answer: "Yes, we do provide visa assistance letter after receiving the passport details of the patient and attendant(s), date of travel to enable in obtaining the medical visa.\n\nNote - If you are travelling on a medical visa, you are required to register at the Foreigners Regional Registration Office within 14 days of your arrival. Your patient coordinator will help you with all these formalities.\n\nAll Patients are required to register with the nearest Police Station or Police Commissioner's office within 24 hours of arrival. Refer to your Visa/Transit document."
  },
  {
    question: "What kind of documents should I bring to my appointment?",
    answer: "A list of your current medications, and the dosage for each. You can also bring vials or containers with you to your first appointment.\nIf requested, any medical information and radiology images (including written radiology reports) that your local doctor has given you.\nAny forms you have been asked to provide.\nName, address and phone number of the referring physician if applicable.\nInformation about your medical insurance, if you have private insurance.\nPassport size photograph of patient and attendants.\n A copy of your passport."
  },
  {
    question: "Can I get an estimate for my treatment?",
    answer: "You can get an estimate from our International Patient Coordinator.\n\nThe patient coordinator will help you with financial details before, during and after the visit. Services offered usually include providing deposit and payment information, estimates and price updates for medical services, and communication with medical insurance companies or third parties on behalf of a patient."
  }
];

const FAQAccordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <Helmet>
        <title>International Patient Desk | Columbiaa Hospital Best Multi-Speciality Hospital Kasturi Nagar Bangalore</title>
        <meta name="description" content="Columbiaa Hospital International Patient Desk in Kasturi Nagar, Bangalore offers medical visa assistance, airport pickup, VISA/FRRO support, accommodation, language interpreters, and personalized care for international patients. Trusted for neurosurgery, brain surgery, spine surgery, cardiology, orthopedics, and multi-speciality medical treatment in India." />
        <meta name="keywords" content="international patients, medical tourism India, medical visa India, medical visa Bangalore, Columbiaa Hospital international patients, international patient desk, international healthcare Bangalore, hospital for international patients, medical treatment India for foreigners, healthcare tourism Bangalore, VISA assistance hospital, FRRO assistance Bangalore, airport pickup hospital Bangalore, international patient coordinator, medical treatment abroad, neurosurgery international patients, brain surgery international patients, spine surgery international patients, international patient services India, medical travel India, healthcare for NRI, NRI hospital Bangalore, hospital for expats Bangalore, medical visa assistance Bangalore, international medical care Bangalore, treatment cost estimate for international patients, medical insurance international patients, accommodation for international patients Bangalore, language interpreter hospital Bangalore, Columbiaa Hospital Kasturi Nagar, best multi-speciality hospital Bangalore, neurosurgeon Bangalore, Dr H V Satish Babu" />
        <meta name="author" content="Columbiaa Hospital" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="International Patient Desk | Columbiaa Hospital Best Multi-Speciality Hospital Kasturi Nagar Bangalore" />
        <meta property="og:description" content="Columbiaa Hospital International Patient Desk in Kasturi Nagar, Bangalore offers medical visa assistance, airport pickup, FRRO support, accommodation, and personalized care for international patients." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com/international-patient-desk" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:locale" content="en_IN" />
        <link rel="canonical" href="https://columbiaahospital.com/international-patient-desk" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Columbiaa Hospital",
              "url": "https://columbiaahospital.com",
              "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8548979899",
                "contactType": "appointments",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi", "Kannada"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Bengaluru",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>
      <section
        className="page-title py-5"
        style={{
          backgroundImage: "url(assets/images/background/page-title-2.jpg)",
          overflowX: "hidden",
        }}
        aria-label="International Patient Services at Columbiaa Hospital, Kasturi Nagar, Bangalore"
      >
        <div
          className="pattern-layer"
          style={{
            backgroundImage: "url(assets/images/shape/pattern-35.png)",
          }}
        ></div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 text-center" data-aos="fade-right">
              <div className="title-box my-4 my-md-0">
                <h1 className="display-4" aria-label="International Patients Desk at Columbiaa Hospital">International Patients Desk</h1>
                <p className="lead">
                Columbiaa Hospital – Your Health Care Partner in Kasturi Nagar, Bangalore.                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container mt-4" aria-label="Contact information for Columbiaa Hospital, Kasturi Nagar">
        <div className="card border-primary shadow">
          <div className="card-body">
            <h2 className="card-title h4">International Patients Desk – Columbiaa Hospital, Kasturi Nagar</h2>
            <p className="card-text">Columbiaa Hospital offers comprehensive healthcare services for international patients.</p>
            <p className="card-text">All inpatients who wish to consult a specialist can schedule their appointments by calling the hospital:</p>
            <ul className="list-unstyled">
              <li><strong>Phone:</strong> <a href="tel:08044484444">080 4448 4444</a> / <a href="tel:08040939899">080 4093 9899</a> / <a href="tel:+918548979899">+91 85489 79899</a></li>
              <li><strong>Email:</strong> <a href="mailto:care@columbiaahospital.com">care@columbiaahospital.com</a></li>
            </ul>
            <p className="card-text">For appointments with the Neuroscience Department, contact via WhatsApp at <a href="tel:+919902586436"><strong>+91 99025 86436</strong></a>.</p>
            <p className="card-text">For surgical packages, Visa-related support (such as requirement letters), and appointment assistance, please contact the Manager on Duty (MOD) at <a href="tel:+918548979899"><strong>+91 85489 79899</strong></a>.</p>
          </div>
        </div>
      </div>

      <div className="container my-5" aria-label="Frequently Asked Questions for Columbiaa Hospital, Kasturi Nagar">
        <h2 className="mb-4">International Patients FAQ – Columbiaa Hospital, Kasturi Nagar</h2>
        <div className="accordion" id="faqAccordion">
          {faqs.map((faq, index) => (
            <div className="card shadow-sm mb-2 border" key={index}>
              <div
                className="card-header d-flex justify-content-between align-items-center"
                onClick={() => toggleIndex(index)}
                style={{ cursor: 'pointer' }}
                aria-expanded={activeIndex === index}
                aria-controls={`faq-body-${index}`}
                role="button"
              >
                <h3 className="mb-0 h6">{faq.question}</h3>
                <span style={{ fontSize: '1.2em', transition: 'transform 0.3s' }}>
                  {activeIndex === index ? '▲' : '▼'}
                </span>
              </div>
              <div
                id={`faq-body-${index}`}
                className={`collapse ${activeIndex === index ? 'show' : ''}`}
              >
                <div className="card-body" style={{ whiteSpace: 'pre-line' }}>
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default FAQAccordion;
